/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckMoveInDateUpdateEligibilityResponse
 */
export interface CheckMoveInDateUpdateEligibilityResponse {
    /**
     * Whether the move-in date can be updated
     * @type {boolean}
     * @memberof CheckMoveInDateUpdateEligibilityResponse
     */
    can_update?: boolean;
    /**
     * Name of the bed that has a conflict (present when can_update is false)
     * @type {string}
     * @memberof CheckMoveInDateUpdateEligibilityResponse
     */
    bed_name?: string;
}

/**
 * Check if a given object implements the CheckMoveInDateUpdateEligibilityResponse interface.
 */
export function instanceOfCheckMoveInDateUpdateEligibilityResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckMoveInDateUpdateEligibilityResponseFromJSON(json: any): CheckMoveInDateUpdateEligibilityResponse {
    return CheckMoveInDateUpdateEligibilityResponseFromJSONTyped(json, false);
}

export function CheckMoveInDateUpdateEligibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckMoveInDateUpdateEligibilityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'can_update': !exists(json, 'can_update') ? undefined : json['can_update'],
        'bed_name': !exists(json, 'bed_name') ? undefined : json['bed_name'],
    };
}

export function CheckMoveInDateUpdateEligibilityResponseToJSON(value?: CheckMoveInDateUpdateEligibilityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'can_update': value.can_update,
        'bed_name': value.bed_name,
    };
}

